<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
import axios from 'axios'

export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    MemberPageHeading: () => import('../components/member/MemberPageHeading.vue'),
    MemberActionButton: () => import('../components/member/MemberActionButton.vue')
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/')
    }
  },
  data () {
    return {
      level1: [],
      level2: [],
      partner: [],
      showdetail: false,
      titleDetail: '',
      history: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    referralLink () {
      return `https://xxmac.vip/register?ref=${this.user.code || ''}`
    },
    level1Count () {
      return this.level1 ? Object.keys(this.level1).length : 0
    },
    level2Count () {
      return this.level2 ? Object.keys(this.level2).length : 0
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key) {
        this.$store.commit('user/SET_LOADING', true)
        axios.get(`https://api.xxmac.win/qpartner/partner/${this.partner.key}`)
        setTimeout(() => {
          this.getPartner()
          this.$store.commit('user/SET_LOADING', false)
        }, 2000)
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: 'คัดลอกเรียบร้อยแล้ว' })
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        return JSON.parse(user)
      }
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/')
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getPartner () {
      const user = this.getUserId()
      if (user) {
        this.level1 = []
        this.level2 = []
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
        firebase.firestore().collection('friends').where('userkey', '==', user.key).get().then((result) => {
          result.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            if (data.level === 1) {
              this.level1.push(data)
            } else {
              this.level2.push(data)
            }
          })
        })
      }
    },
    async showlevel (level) {
      const history = []
      const deposit = []
      const withdraw = []
      if (level === 1) {
        this.titleDetail = 'แนะนำเพื่อน'
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.level1) {
          for (const x in this.level1) {
            this.level1[x].deposit = deposit[this.level1[x].friend] || 0
            this.level1[x].withdraw = withdraw[this.level1[x].friend] || 0
            this.level1[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.level1[x])
          }
        }
      } else {
        this.titleDetail = 'เพื่อนแนะนำเพื่อน'
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.level2) {
          for (const x in this.level2) {
            this.level2[x].deposit = deposit[this.level2[x].friend] || 0
            this.level2[x].withdraw = withdraw[this.level2[x].friend] || 0
            this.level2[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.level2[x])
          }
        }
      }
      this.history = history
      this.showdetail = true
    },
    closeDetail () {
      this.showdetail = false
    }
  }
}
</script>

<template>
  <div>
    <headerSection mainMenu="partner" />
    <main class="member-page partner-page">
      <div class="member-page__content">
        <MemberPageHeading
          eyebrow="Affiliate network"
          title="ลิงก์รับทรัพย์"
          subtitle="แชร์ลิงก์ แนะนำเพื่อน และติดตามรายได้แบบโปร่งใส"
        />

        <section class="member-card partner-share">
          <div class="partner-share__head">
            <strong>ลิงก์แนะนำของคุณ</strong>
            <small>● พร้อมใช้งาน</small>
          </div>
          <div class="partner-ref-link">
            <input type="text" readonly :value="referralLink">
            <button
              type="button"
              v-clipboard:copy="referralLink"
              v-clipboard:success="clipboardSuccessHandler"
            >
              <i class="fa fa-copy" aria-hidden="true" /> คัดลอก
            </button>
          </div>
        </section>

        <div class="partner-grid">
          <button type="button" class="member-card partner-metric" @click="showlevel(1)">
            <span class="partner-metric__label">เพื่อนโดยตรง</span>
            <strong>{{ level1Count }}</strong>
            <small>ดูข้อมูลเมื่อวาน →</small>
          </button>
          <button type="button" class="member-card partner-metric" @click="showlevel(2)">
            <span class="partner-metric__label">เครือข่ายระดับ 2</span>
            <strong>{{ level2Count }}</strong>
            <small>ดูข้อมูลเมื่อวาน →</small>
          </button>
        </div>

        <div class="member-section-head">
          <h2 class="member-section-head__title">รายได้วันนี้</h2>
          <span class="member-section-head__meta">ยอดรอบปัจจุบัน</span>
        </div>
        <section class="member-card partner-income">
          <div class="partner-income__row">
            <span>แนะนำเพื่อน</span>
            <strong>{{ numberWithCommas(partner.total1) }} บาท</strong>
          </div>
          <div class="partner-income__row">
            <span>เพื่อนแนะนำเพื่อน</span>
            <strong>{{ numberWithCommas(partner.total2) }} บาท</strong>
          </div>
          <div class="partner-income__row partner-income__row--total">
            <span>รวมพร้อมรับ</span>
            <strong>{{ numberWithCommas(partner.total) }} บาท</strong>
          </div>
        </section>

        <div class="member-action-wrap">
          <MemberActionButton
            label="โอนรายได้เข้ากระเป๋าหลัก"
            variant="gold"
            :disabled="!partner.total || !partner.key"
            @click="movePartnerToWallet"
          />
        </div>

        <div class="member-section-head">
          <h2 class="member-section-head__title">ภาพรวมเครือข่าย</h2>
          <span class="member-section-head__meta">2 ระดับ</span>
        </div>
        <div class="member-note">
          <span class="member-note__icon">↑</span>
          <span>แตะที่การ์ดจำนวนสมาชิกเพื่อดูยอดฝากและถอนของเครือข่ายจากข้อมูลสรุปเมื่อวาน</span>
        </div>
      </div>
    </main>

    <div
      class="modal x-modal show partner-detail-modal"
      role="dialog"
      aria-modal="true"
      :style="{ display: showdetail ? 'block' : 'none' }"
      @click.self="closeDetail"
    >
      <div class="modal-dialog partner-detail-dialog" role="document">
        <div class="modal-content member-modal partner-detail-content">
          <button type="button" class="partner-modal-close" aria-label="ปิด" @click="closeDetail">×</button>
          <div class="partner-modal-head">
            <span class="partner-modal-head__eyebrow">Network detail</span>
            <h2 class="member-modal__title">{{ titleDetail }}</h2>
            <p>ข้อมูลสรุปยอดเมื่อวาน</p>
          </div>

          <div v-if="history.length" class="member-table-wrap">
            <table class="member-table">
              <thead>
                <tr>
                  <th class="member-table__center">รหัส</th>
                  <th class="member-table__center">วันที่</th>
                  <th class="member-table__right">ฝาก</th>
                  <th class="member-table__right">ถอน</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in history" :key="item.key || item.friend">
                  <td class="member-table__center">{{ item.friend }}</td>
                  <td class="member-table__center">{{ item.createdateShow }}</td>
                  <td class="member-table__right member-positive">{{ numberWithCommas(item.deposit) }}</td>
                  <td class="member-table__right member-negative">{{ numberWithCommas(item.withdraw) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="member-empty">ยังไม่มีข้อมูลสมาชิกในระดับนี้</div>

          <div class="partner-modal-contact">
            ติดปัญหา
            <a :href="lineLink" target="_blank" rel="noopener">ติดต่อฝ่ายบริการลูกค้า</a>
          </div>
        </div>
      </div>
    </div>
    <footerSection />
  </div>
</template>

<style scoped>
.partner-share {
  padding: 18px;
}

.partner-share__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.partner-share__head strong {
  color: #f7faff;
  font-size: 15px;
  font-weight: 500;
}

.partner-share__head small {
  color: #43d7a5;
  font-size: 9px;
}

.partner-ref-link {
  margin-top: 14px;
  padding: 5px 5px 5px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(132, 159, 204, .18);
  border-radius: 13px;
  background: #070b13;
}

.partner-ref-link input {
  min-width: 0;
  height: 34px;
  flex: 1;
  padding: 0;
  overflow: hidden;
  border: 0;
  outline: 0;
  color: #a6b1c4;
  background: transparent;
  font-size: 10px;
  text-overflow: ellipsis;
}

.partner-ref-link button {
  min-width: 88px;
  height: 36px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  background: #286ff2;
  font-size: 10px;
  cursor: pointer;
}

.partner-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}

.partner-metric {
  padding: 16px;
  color: inherit;
  font-family: 'Kanit', sans-serif;
  text-align: left;
  cursor: pointer;
  transition: border-color .2s ease, transform .2s ease;
}

.partner-metric:hover {
  border-color: rgba(87, 137, 234, .42);
  transform: translateY(-1px);
}

.partner-metric__label {
  display: block;
  color: #8793aa;
  font-size: 9px;
}

.partner-metric strong {
  display: block;
  margin-top: 4px;
  color: #f7faff;
  font-size: 24px;
  font-weight: 500;
}

.partner-metric small {
  color: #6ca4ff;
  font-size: 9px;
}

.partner-income {
  padding: 18px;
}

.partner-income__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.partner-income__row + .partner-income__row {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(132, 159, 204, .18);
}

.partner-income__row span {
  color: #9aa6ba;
  font-size: 11px;
}

.partner-income__row strong {
  color: #f7faff;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
}

.partner-income__row--total strong {
  color: #ffca52;
  font-size: 19px;
}

.partner-detail-modal {
  padding: 18px;
  overflow-y: auto;
  background: rgba(0, 0, 0, .74);
  backdrop-filter: blur(10px);
}

.partner-detail-dialog {
  width: min(100%, 640px);
  margin: 6vh auto;
}

.partner-detail-content {
  padding: 24px;
}

.partner-modal-close {
  position: absolute;
  z-index: 2;
  top: 13px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(132, 159, 204, .18);
  border-radius: 11px;
  color: #9ba8bc;
  background: #111a29;
  font-size: 21px;
  line-height: 1;
  cursor: pointer;
}

.partner-modal-head {
  margin-bottom: 18px;
}

.partner-modal-head__eyebrow {
  color: #6ca4ff;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: .14em;
  text-transform: uppercase;
}

.partner-modal-head p {
  margin: 4px 0 0;
  color: #8793aa;
  font-size: 10px;
}

.partner-modal-contact {
  margin-top: 18px;
  color: #8793aa;
  font-size: 11px;
  text-align: center;
}

.partner-modal-contact a {
  margin-left: 5px;
  color: #6ca4ff;
}

@media (max-width: 420px) {
  .partner-ref-link { align-items: stretch; flex-direction: column; padding: 10px; }
  .partner-ref-link input { width: 100%; }
  .partner-ref-link button { width: 100%; }
  .partner-detail-modal { padding: 8px; }
  .partner-detail-content { padding: 20px 12px; }
}
</style>
